import { ApiError } from '@tebuto/api/therapists'
import type { WhoAmI } from '@tebuto/api/therapists/models/WhoAmI'

export type CurrentUserGuardView = 'children' | 'loading-screen' | 'block-spinner' | 'page-error' | 'redirect-401'

export function resolveCurrentUserGuardView({
    userContext,
    error,
    whoAmIBootstrapComplete
}: {
    userContext: WhoAmI | undefined
    error: unknown
    whoAmIBootstrapComplete: boolean
}): CurrentUserGuardView {
    if (userContext) {
        return 'children'
    }

    if (error) {
        if (error instanceof ApiError && error.status === 401) {
            return 'redirect-401'
        }
        return 'page-error'
    }

    return whoAmIBootstrapComplete ? 'block-spinner' : 'loading-screen'
}
